/**
 * @file    Balance.css
 *
 *          Stylesheet for balance component.
 *
 * @author  Kirill Kirnichansky <kirill@kingsds.network>
 * @date    August 2022
 */
button.dcc {
  display: flex;
  column-gap: 0.5em;
  justify-content: flex-end;
  align-items: baseline;
  white-space: preserve;
  cursor: pointer;
  width: fit-content;
  position: relative;
  padding: 0;
  color: var(--primary-hue-main);
  font-family: "Berkeley", Courier, monospace;

  /* Adds an underline underneatht the balance and DCC symbol */
  &:hover {
    box-shadow: 0 -1.5px 0 var(--primary-hue-main) inset;
  }

  img {
    height: 0.7em;
    margin-left: -0.2em;
    filter: var(--primary-hue-main-filter);
  }

  + .copy-to-clipboard {
    display: none;
  }
}

.copy-balance {
  position: absolute;
  right: -2px;
  top: 50%;
  transform: translateY(-50%);
  width: auto;
}
